import ruTranslations from "~/locales/ru.json";
import enTranslations from "~/locales/en.json";
export class I18n {
  constructor() {
    let defaultLang = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ru";
    this.defaultLang = defaultLang || "ru";
    this.translations = {
      ru: ruTranslations,
      en: enTranslations
    };
    this.currentLang = defaultLang;
  }
  t(key) {
    let variables = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // Разбиваем ключ по точкам (например, 'a.b.c')
    const keys = key.split('.');

    // Ищем вложенное значение в текущем языке
    let phrase = keys.reduce((obj, k) => obj?.[k], this.translations[this.currentLang]);

    // Если не найдено, ищем в языке по умолчанию
    if (phrase === undefined) {
      phrase = keys.reduce((obj, k) => obj?.[k], this.translations[this.defaultLang]);
    }

    // Если всё равно не найдено, возвращаем ключ как строку
    if (phrase === undefined) {
      console.warn(`Translation key "${key}" not found`);
      return key;
    }

    // Заменяем переменные в строке
    return phrase.replace(/\{\{\s*(\w+)\s*}}/g, (_, varName) => variables[varName] || "");
  }
}